// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @enum {number}
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export enum StandardAttributeKey{
  NO_KEY= 0,
  MACHINE_ID= 1,
  OS_TYPE= 2,
  OS_VERSION= 3,
  PROCESS_ID= 4,
  PRODUCT_NAME= 5,
  PRODUCT_VERSION= 6,
  LOCALE= 7,
  LANGUAGE= 8,
  ONLINE_POD_UUID= 9,
  TSM_CLUSTER_ID= 10,
  KUBE_POD_NAME= 11,
  SERVICE_NAME= 12,
  CLIENT_LIB_NAME= 13,
  USER_NAME= 14,
  USER_EMAIL= 15,
  EVENT_ID= 1000,
  WORKBOOK_ID= 10001,
  SITE_LUID= 10002,
  SESSION_ID= 10003,
  DATASOURCE_ID= 10004,
  WORKBOOK_LUID= 10005,
  DATASOURCE_IS_PUBLISHED= 10006,
  DATASOURCE_IS_EXTRACT= 10007,
  DATASOURCE_IS_LEGACY= 10008,
  DATASOURCE_IS_CUBE= 10009,
  WORKSHEET_ID= 10010,
  SITE_ID= 10011,
  USER_LUID= 10012,
  USER_ID= 10013,
  DATASOURCE_LUID= 10014,
  DOMAIN_ID= 10015,
  SITE_ROLE= 10016,
  SITE_ROLE_ID= 10017,
  SYSTEM_USER_ID= 10018,
  ATR_CHAIN_IDS= 20001,
  FULFILLMENT_IDS= 20002,
  INSTALLATION_TYPE= 20003
}};

/**
 * @enum {number}
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export enum AnyValue{
  NONE= 0,
  DoubleValue= 1,
  StringValue= 2,
  BooleanValue= 3,
  Int64Value= 4,
  ListStringValue= 5
}};

/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class DoubleValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns DoubleValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):DoubleValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param DoubleValue= obj
 * @returns DoubleValue
 */
static getRootAsDoubleValue(bb:flatbuffers.ByteBuffer, obj?:DoubleValue):DoubleValue {
  return (obj || new DoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param DoubleValue= obj
 * @returns DoubleValue
 */
static getSizePrefixedRootAsDoubleValue(bb:flatbuffers.ByteBuffer, obj?:DoubleValue):DoubleValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new DoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns number
 */
Value():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startDoubleValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param number Value
 */
static addValue(builder:flatbuffers.Builder, Value:number) {
  builder.addFieldFloat64(0, Value, 0.0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endDoubleValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createDoubleValue(builder:flatbuffers.Builder, Value:number):flatbuffers.Offset {
  DoubleValue.startDoubleValue(builder);
  DoubleValue.addValue(builder, Value);
  return DoubleValue.endDoubleValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class StringValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns StringValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):StringValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StringValue= obj
 * @returns StringValue
 */
static getRootAsStringValue(bb:flatbuffers.ByteBuffer, obj?:StringValue):StringValue {
  return (obj || new StringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StringValue= obj
 * @returns StringValue
 */
static getSizePrefixedRootAsStringValue(bb:flatbuffers.ByteBuffer, obj?:StringValue):StringValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Value():string|null
Value(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Value(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startStringValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset ValueOffset
 */
static addValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, ValueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endStringValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createStringValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset):flatbuffers.Offset {
  StringValue.startStringValue(builder);
  StringValue.addValue(builder, ValueOffset);
  return StringValue.endStringValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class BooleanValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns BooleanValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):BooleanValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param BooleanValue= obj
 * @returns BooleanValue
 */
static getRootAsBooleanValue(bb:flatbuffers.ByteBuffer, obj?:BooleanValue):BooleanValue {
  return (obj || new BooleanValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param BooleanValue= obj
 * @returns BooleanValue
 */
static getSizePrefixedRootAsBooleanValue(bb:flatbuffers.ByteBuffer, obj?:BooleanValue):BooleanValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BooleanValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns boolean
 */
Value():boolean {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
};

/**
 * @param flatbuffers.Builder builder
 */
static startBooleanValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param boolean Value
 */
static addValue(builder:flatbuffers.Builder, Value:boolean) {
  builder.addFieldInt8(0, +Value, +false);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endBooleanValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createBooleanValue(builder:flatbuffers.Builder, Value:boolean):flatbuffers.Offset {
  BooleanValue.startBooleanValue(builder);
  BooleanValue.addValue(builder, Value);
  return BooleanValue.endBooleanValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class Int64Value {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns Int64Value
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Int64Value {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Int64Value= obj
 * @returns Int64Value
 */
static getRootAsInt64Value(bb:flatbuffers.ByteBuffer, obj?:Int64Value):Int64Value {
  return (obj || new Int64Value()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Int64Value= obj
 * @returns Int64Value
 */
static getSizePrefixedRootAsInt64Value(bb:flatbuffers.ByteBuffer, obj?:Int64Value):Int64Value {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Int64Value()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns flatbuffers.Long
 */
Value():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param flatbuffers.Builder builder
 */
static startInt64Value(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long Value
 */
static addValue(builder:flatbuffers.Builder, Value:flatbuffers.Long) {
  builder.addFieldInt64(0, Value, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endInt64Value(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createInt64Value(builder:flatbuffers.Builder, Value:flatbuffers.Long):flatbuffers.Offset {
  Int64Value.startInt64Value(builder);
  Int64Value.addValue(builder, Value);
  return Int64Value.endInt64Value(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class ListStringValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns ListStringValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):ListStringValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ListStringValue= obj
 * @returns ListStringValue
 */
static getRootAsListStringValue(bb:flatbuffers.ByteBuffer, obj?:ListStringValue):ListStringValue {
  return (obj || new ListStringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ListStringValue= obj
 * @returns ListStringValue
 */
static getSizePrefixedRootAsListStringValue(bb:flatbuffers.ByteBuffer, obj?:ListStringValue):ListStringValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ListStringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array
 */
Value(index: number):string
Value(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
Value(index: number,optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
};

/**
 * @returns number
 */
ValueLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startListStringValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset ValueOffset
 */
static addValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, ValueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createValueVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startValueVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endListStringValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createListStringValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset):flatbuffers.Offset {
  ListStringValue.startListStringValue(builder);
  ListStringValue.addValue(builder, ValueOffset);
  return ListStringValue.endListStringValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class StringKeyAnyValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns StringKeyAnyValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):StringKeyAnyValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StringKeyAnyValue= obj
 * @returns StringKeyAnyValue
 */
static getRootAsStringKeyAnyValue(bb:flatbuffers.ByteBuffer, obj?:StringKeyAnyValue):StringKeyAnyValue {
  return (obj || new StringKeyAnyValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StringKeyAnyValue= obj
 * @returns StringKeyAnyValue
 */
static getSizePrefixedRootAsStringKeyAnyValue(bb:flatbuffers.ByteBuffer, obj?:StringKeyAnyValue):StringKeyAnyValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StringKeyAnyValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
key():string|null
key(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
key(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.types.AnyValue
 */
valueType():com.tableausoftware.endeavour.protocol.v1.types.AnyValue {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.types.AnyValue.NONE;
};

/**
 * @param flatbuffers.Table obj
 * @returns ?flatbuffers.Table
 */
value<T extends flatbuffers.Table>(obj:T):T|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startStringKeyAnyValue(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset keyOffset
 */
static addKey(builder:flatbuffers.Builder, keyOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, keyOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.types.AnyValue valueType
 */
static addValueType(builder:flatbuffers.Builder, valueType:com.tableausoftware.endeavour.protocol.v1.types.AnyValue) {
  builder.addFieldInt8(1, valueType, com.tableausoftware.endeavour.protocol.v1.types.AnyValue.NONE);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset valueOffset
 */
static addValue(builder:flatbuffers.Builder, valueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, valueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endStringKeyAnyValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createStringKeyAnyValue(builder:flatbuffers.Builder, keyOffset:flatbuffers.Offset, valueType:com.tableausoftware.endeavour.protocol.v1.types.AnyValue, valueOffset:flatbuffers.Offset):flatbuffers.Offset {
  StringKeyAnyValue.startStringKeyAnyValue(builder);
  StringKeyAnyValue.addKey(builder, keyOffset);
  StringKeyAnyValue.addValueType(builder, valueType);
  StringKeyAnyValue.addValue(builder, valueOffset);
  return StringKeyAnyValue.endStringKeyAnyValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.types{
export class StandardKeyAnyValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns StandardKeyAnyValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):StandardKeyAnyValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StandardKeyAnyValue= obj
 * @returns StandardKeyAnyValue
 */
static getRootAsStandardKeyAnyValue(bb:flatbuffers.ByteBuffer, obj?:StandardKeyAnyValue):StandardKeyAnyValue {
  return (obj || new StandardKeyAnyValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param StandardKeyAnyValue= obj
 * @returns StandardKeyAnyValue
 */
static getSizePrefixedRootAsStandardKeyAnyValue(bb:flatbuffers.ByteBuffer, obj?:StandardKeyAnyValue):StandardKeyAnyValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StandardKeyAnyValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey
 */
key():com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? /**  */ (this.bb!.readUint32(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey.NO_KEY;
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.types.AnyValue
 */
valueType():com.tableausoftware.endeavour.protocol.v1.types.AnyValue {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.types.AnyValue.NONE;
};

/**
 * @param flatbuffers.Table obj
 * @returns ?flatbuffers.Table
 */
value<T extends flatbuffers.Table>(obj:T):T|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startStandardKeyAnyValue(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey key
 */
static addKey(builder:flatbuffers.Builder, key:com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey) {
  builder.addFieldInt32(0, key, com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey.NO_KEY);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.types.AnyValue valueType
 */
static addValueType(builder:flatbuffers.Builder, valueType:com.tableausoftware.endeavour.protocol.v1.types.AnyValue) {
  builder.addFieldInt8(1, valueType, com.tableausoftware.endeavour.protocol.v1.types.AnyValue.NONE);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset valueOffset
 */
static addValue(builder:flatbuffers.Builder, valueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, valueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endStandardKeyAnyValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createStandardKeyAnyValue(builder:flatbuffers.Builder, key:com.tableausoftware.endeavour.protocol.v1.types.StandardAttributeKey, valueType:com.tableausoftware.endeavour.protocol.v1.types.AnyValue, valueOffset:flatbuffers.Offset):flatbuffers.Offset {
  StandardKeyAnyValue.startStandardKeyAnyValue(builder);
  StandardKeyAnyValue.addKey(builder, key);
  StandardKeyAnyValue.addValueType(builder, valueType);
  StandardKeyAnyValue.addValue(builder, valueOffset);
  return StandardKeyAnyValue.endStandardKeyAnyValue(builder);
}
}
}
